(function () {
  'use strict';

  var uploadedFiles   = [];
  var filePondInstance = null;
  var lastSlotCount   = 0;
  var initialized     = false;

  /* ── Helpers ── */
  function openModal(id)  { var el = document.getElementById(id); if (el) el.classList.add('is-open'); }
  function closeModal(id) { var el = document.getElementById(id); if (el) el.classList.remove('is-open'); }

  function bindOverlayClose(id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('click', function (e) { if (e.target === el) closeModal(id); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModal('upload-images-modal'); closeModal('product-preview-modal'); }
  });

  /* ── Slot count ── */
  function getSlotCount() {
    var bundleSize = 0;
    var h1 = document.querySelector('h1');
    if (h1) {
      var m = h1.textContent.match(/bundle\s*[-–]\s*(\d+)/i);
      if (!m) m = h1.textContent.match(/[-–]\s*(\d+)/);
      if (m) bundleSize = parseInt(m[1], 10);
    }
    if (!bundleSize) {
      var wrapper = document.querySelector('.cl-upload--wrapper');
      if (wrapper) {
        var mf = wrapper.getAttribute('data-max-files') || wrapper.getAttribute('max-files');
        if (mf) bundleSize = parseInt(mf, 10);
      }
    }
    if (!bundleSize) {
      var qtyInput = document.querySelector('input[name="quantity"]');
      if (qtyInput) bundleSize = parseInt(qtyInput.value, 10) || 1;
    }
    return Math.min(Math.max(bundleSize, 1), 24);
  }

  /* ── Skip cart-context FilePond instances ── */
  function isInsideCart(el) {
    return !!(el.closest('.cart-item') || el.closest('.cart-drawer') ||
              el.closest('[id*="cart"]') || el.closest('[class*="cart"]'));
  }

  function resetCountLabel() {
    var countEl = document.querySelector('.iup-upload-count');
    if (countEl) { countEl.textContent = ''; countEl.className = 'iup-upload-count'; }
  }

  /* ── FilePond interception ── */
  function interceptFilePond() {
    var containers = document.querySelectorAll('.upload-container');
    if (!containers.length) return false;

    var found = false;
    containers.forEach(function (container) {
      if (container.dataset.iupIntercepted || isInsideCart(container)) return;
      container.dataset.iupIntercepted = 'true';
      found = true;

      container.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'iup-filepond-trigger';
      btn.setAttribute('aria-label', 'Upload photos');
      btn.textContent = 'UPLOAD PHOTOS';

      var statusEl = document.createElement('div');
      statusEl.className = 'iup-upload-count';
      statusEl.setAttribute('aria-live', 'polite');

      var progressWrap = document.createElement('div');
      progressWrap.className = 'iup-upload-progress-wrap';
      var progressFill = document.createElement('div');
      progressFill.className = 'iup-upload-progress-fill';
      var progressLabel = document.createElement('span');
      progressLabel.className = 'iup-upload-progress-label';
      progressLabel.textContent = 'Uploading… Please wait';
      progressWrap.appendChild(progressFill);
      progressWrap.appendChild(progressLabel);
      container.parentNode.insertBefore(btn, container);
      container.parentNode.insertBefore(progressWrap, container);
      container.parentNode.insertBefore(statusEl, btn);

      btn.addEventListener('click', function () {
        // Full reset of file selection on every button click
        uploadedFiles = [];
        refreshPreviewGrid();
        resetCountLabel();

        var fpInput = container.querySelector('.filepond--browser');
        if (fpInput && window.FilePond) {
          filePondInstance = window.FilePond.find(fpInput) || null;
        }

        var currentCount = getSlotCount();
        if (lastSlotCount && lastSlotCount !== currentCount) {
          var fp2 = document.querySelector('.filepond--browser');
          if (fp2 && window.FilePond) {
            var inst2 = filePondInstance || window.FilePond.find(fp2) || null;
            if (inst2 && typeof inst2.removeFiles === 'function') inst2.removeFiles();
          }
        }
        var modal = document.getElementById('product-preview-modal');
        if (modal) modal.dataset.slots = currentCount;
        lastSlotCount = currentCount;

        openModal('upload-images-modal');
      });
    });
    return found;
  }

  function waitForFilePond() {
    if (interceptFilePond()) return;
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function () {
      if (interceptFilePond()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 30000);
  }

  /* ── Progress bar ── */
  function getProgressBar() { return document.querySelector('.iup-upload-progress-wrap'); }
  function showProgress() { var b = getProgressBar(); if (b) b.classList.add('is-active'); }
  function hideProgress() {
    var b = getProgressBar(); if (!b) return;
    b.classList.add('is-done');
    setTimeout(function () { b.classList.remove('is-active', 'is-done'); }, 800);
  }

  /* ══════════════════════════════════════════════════════════════════════
     FETCH INTERCEPTOR — fast qty normalisation
     ══════════════════════════════════════════════════════════════════════
     Upload Lift calls /cart/add.js once per photo, so N photos → qty N.
     Instead of waiting a fixed 2 s, we intercept Upload Lift's own fetch
     calls.  After 500 ms of silence (no more cart API calls), we normalise
     qty back to 1.  This means the cart corrects itself within ~600 ms of
     the last photo being processed — much faster than before.
  ══════════════════════════════════════════════════════════════════════ */
  var _intercepting     = false;
  var _debounceTimer    = null;
  var _interceptTimeout = null;
  var _onSettled        = null;
  var _wrapper          = null;

  /**
   * HARDENING NOTE
   * --------------
   * The previous version of this interceptor read the saved original through a
   * mutable module variable and nulled that variable on teardown. If anything
   * else on the page re-installed our wrapper (another app restoring its own
   * saved window.fetch reference, a second activation, an app that patches
   * fetch after us), every subsequent fetch() threw
   * "Cannot read properties of null (reading 'apply')" — which broke add to
   * cart for the rest of the page session and only cleared on a full reload.
   * That matches the "unexpected error that won't go away until I close the
   * site" reports exactly.
   *
   * Four guarantees now:
   *   1. The wrapper closes over its own immutable `original` — never null.
   *   2. We never wrap an already-wrapped fetch (idempotent activation).
   *   3. Teardown only restores if window.fetch is still OUR wrapper, so we
   *      don't clobber a patch a third-party app installed after us.
   *   4. The wrapper never throws: any bookkeeping error is swallowed and the
   *      caller still gets the real fetch promise.
   */
  function activateFetchIntercept(onSettled) {
    if (_intercepting) return;
    _onSettled = onSettled;

    if (window.fetch && window.fetch.__iupPatched) {
      // Already wrapped (ours, re-installed by someone else). Reuse it.
      _intercepting = true;
      scheduleInterceptTimeout();
      return;
    }

    var original = window.fetch;
    if (typeof original !== 'function') return;

    _intercepting = true;

    _wrapper = function (input, init) {
      var promise = original.apply(this, arguments);

      try {
        var url = typeof input === 'string' ? input
                : (input && typeof input === 'object' && input.url) ? input.url : '';

        if (_intercepting && (url.indexOf('cart/add') !== -1 || url.indexOf('cart/change') !== -1)) {
          promise.then(function () {
            clearTimeout(_debounceTimer);
            // 500 ms after the LAST cart call → cart has settled → normalise
            _debounceTimer = setTimeout(function () {
              if (_intercepting) {
                deactivateFetchIntercept();
                if (typeof _onSettled === 'function') _onSettled();
              }
            }, 500);
          }, function () {
            // Upload Lift's own call failed — still settle so the cart
            // re-renders and the shopper is not left with a stale drawer.
            clearTimeout(_debounceTimer);
            _debounceTimer = setTimeout(function () {
              if (_intercepting) {
                deactivateFetchIntercept();
                if (typeof _onSettled === 'function') _onSettled();
              }
            }, 500);
          });
        }
      } catch (e) {
        console.warn('[IUP] fetch interceptor bookkeeping failed:', e);
      }

      return promise;
    };
    _wrapper.__iupPatched = true;
    _wrapper.__iupOriginal = original;

    window.fetch = _wrapper;
    scheduleInterceptTimeout();
  }

  function scheduleInterceptTimeout() {
    clearTimeout(_interceptTimeout);
    // Safety: deactivate after 90 s no matter what
    _interceptTimeout = setTimeout(function () {
      deactivateFetchIntercept();
    }, 90000);
  }

  function deactivateFetchIntercept() {
    _intercepting = false;
    clearTimeout(_debounceTimer);
    clearTimeout(_interceptTimeout);
    // Only unwind if OUR wrapper is still the live window.fetch. Restoring
    // blindly would drop a patch installed after ours.
    if (_wrapper && window.fetch === _wrapper && typeof _wrapper.__iupOriginal === 'function') {
      window.fetch = _wrapper.__iupOriginal;
    }
    _wrapper = null;
  }

  /* ── Cart helpers ── */

  /**
   * Surface a cart failure to the shopper using the shared error vocabulary in
   * assets/cart-errors.js. Previously these failures were console-only, so a
   * throttled or rejected cart write after a photo upload looked like nothing
   * happened at all.
   */
  function reportCartProblem(error) {
    var message = (window.CartErrors && window.CartErrors.messageForThrown)
      ? window.CartErrors.messageForThrown(error)
      : "We couldn't refresh your cart. Please reload the page to check your bundle.";
    if (typeof window.showToast === 'function') window.showToast(message);
  }

  function getCurrentVariantId() {
    var selectors = [
      'form[action="/cart/add"] input[name="id"]',
      'form[action*="cart/add"] input[name="id"]',
      'input[name="id"]',
      'select[name="id"]',
      '[data-variant-id]',
      '[data-product-variant-id]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        var val = el.value || el.dataset.variantId || el.dataset.productVariantId;
        if (val) return String(val);
      }
    }
    return null;
  }

  /**
   * Dispatch cart:rerender in the shape the theme's CustomCart expects:
   *   event.detail.sections["cart-drawer"] = rendered HTML
   *
   * /cart/change.js with sections param returns:
   *   { items:[...], sections:{"cart-drawer":"html"} }
   *   → detail = data   (data.sections already correct)
   *
   * /?sections=cart-drawer,cart-icon returns:
   *   { "cart-drawer":"html", "cart-icon":"html" }
   *   → detail = { sections: data }  (needs wrapping)
   */
  function dispatchCartRerender(data, wrapInSections) {
    var detail = wrapInSections ? { sections: data } : data;
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:rerender', { detail: detail, bubbles: true })
    );
  }

  function fetchSectionsAndRerender() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-drawer,cart-icon')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // /?sections=... returns the sections object directly (NOT nested under .sections)
        dispatchCartRerender(data, true);
      })
      .catch(function () {});
  }

  /**
   * Find any cart item for the current variant with qty > 1 and set it to 1.
   * Then re-render the cart drawer via the theme's cart:rerender event.
   */
  function normalizeQtyAndRerender() {
    var variantId = getCurrentVariantId();
    if (!variantId) { console.warn('[IUP] normalizeQtyAndRerender: no variantId'); return; }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var overQtyLines = [];
        cart.items.forEach(function (item, idx) {
          if (String(item.variant_id) === variantId && item.quantity > 1) {
            overQtyLines.push(idx + 1); // 1-indexed
          }
        });

        if (!overQtyLines.length) {
          console.log('[IUP] normalizeQtyAndRerender: all qtys already 1');
          fetchSectionsAndRerender();
          return;
        }

        console.log('[IUP] Normalising qty for lines:', overQtyLines);

        // Process in reverse so line numbers stay stable
        var toProcess = overQtyLines.slice().reverse();
        var silent    = toProcess.slice(1);
        var finalLine = toProcess[0];

        var chain = silent.reduce(function (p, ln) {
          return p.then(function () {
            return fetch(root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: ln, quantity: 1 })
            });
          });
        }, Promise.resolve());

        return chain.then(function () {
          return fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: finalLine,
              quantity: 1,
              sections: 'cart-drawer,cart-icon'
            })
          });
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            // /cart/change.js returns { items:[...], sections:{...} } — no wrapping needed
            dispatchCartRerender(data, false);
          })
          .catch(function (err) {
            console.warn('[IUP] cart/change.js failed:', err);
            // Quantities may be wrong in the drawer — re-render from the server
            // so the shopper sees the real cart rather than a stale one.
            fetchSectionsAndRerender();
            reportCartProblem(err);
          });
      })
      .catch(function (err) {
        console.warn('[IUP] cart.js fetch failed:', err);
        reportCartProblem(err);
      });
  }

  /* ── Feed files into FilePond ── */
  function commitFilesToFilePond(files) {
    if (!files || !files.length) return;

    showProgress();

    var countEl = document.querySelector('.iup-upload-count');
    var total   = files.length;
    var done    = 0;

    if (countEl) {
      countEl.textContent = '0 of ' + total + ' photo' + (total !== 1 ? 's' : '') + ' uploaded';
      countEl.className   = 'iup-upload-count is-active';
    }

    // Activate fetch interceptor BEFORE feeding files to Upload Lift.
    // When Upload Lift's last cart/add.js call settles (~500 ms of silence),
    // the interceptor fires normalizeQtyAndRerender() automatically.
    activateFetchIntercept(function () {
      console.log('[IUP] Cart calls settled — normalising qty');
      normalizeQtyAndRerender();
    });

    var fpInput = document.querySelector('.filepond--browser');
    var inst    = filePondInstance || (fpInput && window.FilePond && window.FilePond.find(fpInput)) || null;

    function doAdd() {
      if (inst && typeof inst.addFiles === 'function') {
        inst.addFiles(files);
      } else if (fpInput) {
        try {
          var dt = new DataTransfer();
          files.forEach(function (f) { dt.items.add(f); });
          fpInput.files = dt.files;
          fpInput.dispatchEvent(new Event('change', { bubbles: true }));
          fpInput.dispatchEvent(new Event('input',  { bubbles: true }));
        } catch (e) { console.warn('[IUP] DataTransfer fallback failed:', e); }
      }
    }

    if (inst && typeof inst.removeFiles === 'function') {
      inst.removeFiles();
      setTimeout(doAdd, 100);
    } else {
      doAdd();
    }

    // Track progress for the upload counter label only
    var fpRoot = document.querySelector('.filepond--root');
    if (fpRoot) {
      fpRoot.addEventListener('FilePond:processfile', function onFileDone() {
        done++;
        if (countEl) {
          if (done >= total) {
            countEl.textContent = '\u2713 All photos have been uploaded!';
            countEl.className   = 'iup-upload-count is-done';
          } else {
            countEl.textContent = done + ' of ' + total + ' photo' + (total !== 1 ? 's' : '') + ' uploaded';
          }
        }
        if (done >= total) {
          fpRoot.removeEventListener('FilePond:processfile', onFileDone);
          hideProgress();
        }
      });
      setTimeout(hideProgress, 60000);
    } else {
      setTimeout(hideProgress, 8000);
    }
  }

  /* ── Trigger Upload Lift crop editor for a single file ── */
  function triggerCropForFile(file) {
    var idx = uploadedFiles.indexOf(file);
    if (idx > -1) uploadedFiles.splice(idx, 1);
    closeModal('product-preview-modal');
    var fpInput = document.querySelector('.filepond--browser');
    if (fpInput) {
      try {
        var dt = new DataTransfer();
        dt.items.add(file);
        fpInput.files = dt.files;
        fpInput.dispatchEvent(new Event('change', { bubbles: true }));
        fpInput.dispatchEvent(new Event('input',  { bubbles: true }));
      } catch (e) {}
    }
    if (window.FilePond) {
      var inst = filePondInstance || (fpInput && window.FilePond.find(fpInput)) || null;
      if (inst && typeof inst.addFile === 'function') inst.addFile(file);
    }
    refreshPreviewGrid();
  }

  /* ── Handle new file selection ─────────────────────────────────────────
     IMPORTANT: we REPLACE uploadedFiles each time the user picks files.
     Appending (push) caused stacking when the user opened the file picker
     more than once in the same page session without clicking Add to Cart.
     Replacing ensures the preview always shows ONLY the current selection.
  ── */
  function handleFiles(files) {
    var imageFiles = files.filter(function (f) { return f.type.startsWith('image/'); });
    if (!imageFiles.length) return;
    uploadedFiles = imageFiles;        // REPLACE — never stack
    refreshPreviewGrid();
    closeModal('upload-images-modal');
    openModal('product-preview-modal');
  }

  /* ── Upload modal ── */
  function initUploadModal() {
    var overlay = document.getElementById('upload-images-modal');
    if (!overlay || overlay.dataset.iupInit) return;
    overlay.dataset.iupInit = 'true';

    var dropzone  = overlay.querySelector('.iup-dropzone');
    var fileInput = overlay.querySelector('.iup-dropzone__file-input');
    var btnUpload = overlay.querySelector('.iup-btn-upload');
    var btnCancel = overlay.querySelector('.iup-btn-cancel');
    var btnClose  = overlay.querySelector('.iup-header__close');

    function pick() { if (fileInput) fileInput.click(); }
    if (btnUpload) btnUpload.addEventListener('click', pick);
    if (dropzone)  dropzone.addEventListener('click', function (e) { if (!btnUpload.contains(e.target)) pick(); });
    if (fileInput) fileInput.addEventListener('change', function () {
      handleFiles(Array.from(fileInput.files));
      fileInput.value = '';
    });
    if (dropzone) {
      dropzone.addEventListener('dragover',  function (e) { e.preventDefault(); dropzone.classList.add('drag-over'); });
      dropzone.addEventListener('dragleave', function ()  { dropzone.classList.remove('drag-over'); });
      dropzone.addEventListener('drop', function (e) {
        e.preventDefault(); dropzone.classList.remove('drag-over');
        handleFiles(Array.from(e.dataTransfer.files));
      });
    }
    if (btnClose)  btnClose.addEventListener('click',  function () { closeModal('upload-images-modal'); });
    if (btnCancel) btnCancel.addEventListener('click', function () { closeModal('upload-images-modal'); });
    bindOverlayClose('upload-images-modal');
    overlay.querySelectorAll('.iup-source-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { console.log('[IUP] Source:', btn.dataset.source); });
    });
  }

  /* ── Preview modal ── */
  function initPreviewModal() {
    var overlay = document.getElementById('product-preview-modal');
    if (!overlay || overlay.dataset.iupInit) return;
    overlay.dataset.iupInit = 'true';

    var btnClose     = overlay.querySelector('.iup-header__close');
    var btnAddToCart = overlay.querySelector('.iup-btn-add-to-cart');

    if (btnClose) btnClose.addEventListener('click', function () { closeModal('product-preview-modal'); });
    bindOverlayClose('product-preview-modal');

    if (btnAddToCart) {
      btnAddToCart.addEventListener('click', function () {
        var filesToSubmit = uploadedFiles.slice();
        commitFilesToFilePond(filesToSubmit);
        document.dispatchEvent(new CustomEvent('iup:files-confirmed', { detail: { files: filesToSubmit } }));
        uploadedFiles = [];   // clear after handing off to FilePond
        refreshPreviewGrid();
        closeModal('product-preview-modal');
      });
    }
  }

  /* ── Thumbnail grid ── */
  function refreshPreviewGrid() {
    var grid  = document.querySelector('#product-preview-modal .iup-thumb-grid');
    var label = document.querySelector('#product-preview-modal .iup-preview-panel__selected');
    if (!grid) return;
    var modal = document.getElementById('product-preview-modal');
    var slots = parseInt(modal && modal.dataset.slots, 10) || getSlotCount();
    grid.innerHTML = '';
    for (var i = 0; i < slots; i++) { grid.appendChild(buildThumb(uploadedFiles[i] || null, i)); }
    if (label) label.textContent = 'Selected ' + Math.min(uploadedFiles.length, slots) + '/' + slots;
  }

  function buildThumb(file, index) {
    var wrap = document.createElement('div');
    wrap.className = 'iup-thumb';
    wrap.dataset.index = index;
    if (file) {
      var img = document.createElement('img');
      img.src = URL.createObjectURL(file);
      img.alt = file.name;
      wrap.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = 'iup-thumb__placeholder';
      ph.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909M3 3h18M3 21h18M3 12h.008v.008H3V12z"/></svg>';
      wrap.appendChild(ph);
    }
    var bar = document.createElement('div');
    bar.className = 'iup-thumb__actions';
    var del = document.createElement('button');
    del.className = 'iup-thumb__action-btn'; del.title = 'Remove';
    del.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"/></svg>';
    (function (idx) {
      del.addEventListener('click', function () { if (uploadedFiles[idx]) { uploadedFiles.splice(idx, 1); refreshPreviewGrid(); } });
    }(index));
    var right = document.createElement('div');
    right.className = 'iup-thumb__right-actions';
    var crop = document.createElement('button');
    crop.className = 'iup-thumb__action-btn'; crop.title = 'Crop / Edit';
    crop.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M7 7H3m4 0v14m0-14h10M7 7l4 4M17 3v4m0 0H7m10 0v10m0 0H3"/></svg>';
    var settings = document.createElement('button');
    settings.className = 'iup-thumb__action-btn'; settings.title = 'Settings';
    settings.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>';
    (function (idx) {
      function openCrop() { if (uploadedFiles[idx]) triggerCropForFile(uploadedFiles[idx]); }
      crop.addEventListener('click', openCrop);
      settings.addEventListener('click', openCrop);
    }(index));
    right.appendChild(crop); right.appendChild(settings);
    bar.appendChild(del); bar.appendChild(right);
    wrap.appendChild(bar);
    return wrap;
  }

  /* ── Variant change listener ── */
  function listenForVariantChange() {
    function onVariantChanged() {
      uploadedFiles = [];
      resetCountLabel();
      var fpInput = document.querySelector('.filepond--browser');
      if (fpInput && window.FilePond) {
        var inst = filePondInstance || window.FilePond.find(fpInput) || null;
        if (inst && typeof inst.removeFiles === 'function') inst.removeFiles();
      }
      closeModal('product-preview-modal');
      setTimeout(function () {
        var modal = document.getElementById('product-preview-modal');
        var c = getSlotCount();
        if (modal) modal.dataset.slots = c;
        lastSlotCount = c;
        refreshPreviewGrid();
      }, 200);
    }
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') onVariantChanged(); });
    document.addEventListener('click', function (e) {
      var sel = e.target.closest('[data-value],[data-variant-id],.swatch__input,.variant__button,.js-variant-button,[data-option-value],.kaching-bundle-option,.pack-option,.choose-pack');
      if (sel) setTimeout(onVariantChanged, 250);
    });
    ['variant:changed', 'product:variant:change', 'variantChange'].forEach(function (ev) {
      document.addEventListener(ev, onVariantChanged);
    });
  }

  /* ── Public API ── */
  window.ImageUploadModals = {
    openUpload:  function () { openModal('upload-images-modal'); },
    openPreview: function () { refreshPreviewGrid(); openModal('product-preview-modal'); },
    close:       function (id) { closeModal(id); },
    getFiles:    function () { return uploadedFiles.slice(); }
  };

  /* ── Init ── */
  function init() {
    if (initialized) { waitForFilePond(); return; }
    initialized = true;
    initUploadModal();
    initPreviewModal();
    listenForVariantChange();
    document.querySelectorAll('[data-open-upload-modal]').forEach(function (b) {
      b.addEventListener('click', window.ImageUploadModals.openUpload);
    });
    waitForFilePond();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();
